module.exports = __webpack_public_path__ + "img/payment-methods-pl.cc913e4a.png";